<template>
  <div class="new-block" @click="smiles = false">
    <!-- Тип блока -->
    <div class="new-block-type">
      <div
        class="new-block-type__item"
        :class="{ active: block.type === 'paragraph' }"
        @click="changeType('paragraph')"
      >
        <Icons :icon="'paragraph'" />
      </div>
      <div
        class="new-block-type__item"
        :class="{ active: block.type === 'image' }"
        @click="changeType('image')"
        v-if="showImageChange(block.type)"
      >
        <Icons :icon="'image'" />
      </div>
      <div
        class="new-block-type__item"
        :class="{ active: block.type === 'h3' }"
        @click="changeType('h3')"
      >
        <p>H</p>
      </div>
      <div
        class="new-block-type__item"
        :class="{ active: block.type === 'youtube' }"
        @click="changeType('youtube')"
      >
        <p>Y</p>
      </div>
    </div>
    <!-- Абзац -->
    <TextareaAutosize
      class="new-paragraph"
      v-model="block.value"
      :placeholder="placeholder"
      @input="changeValue(block.value)"
      v-if="block.type === 'paragraph'"
      maxlength="1000"
    />
    <!-- Заголовок -->
    <TextareaAutosize
      class="new-paragraph h3"
      v-model="block.value"
      placeholder="Заголовок H3"
      @input="changeValue(block.value)"
      v-if="block.type === 'h3'"
      maxlength="1000"
    />
    <!-- Youtube -->
    <TextareaAutosize
      class="new-paragraph youtube"
      v-model="block.value"
      placeholder="Вставьте ссылку на видео YouTube (embed)"
      @input="changeValue(block.value)"
      v-if="block.type === 'youtube'"
      maxlength="1000"
    />
    <!-- Инструменты абзаца, смайлики -->
    <div class="new-paragraph-panel" v-if="block.type === 'paragraph'">
      <div class="chat-addsmile" @click.stop="openSmiles()">
        <img src="@/assets/images/icons/smile.svg" width="24px" />
        
      </div>
    </div>
    <div class="chat-picker" v-show="smiles" @click.stop>
        <div class="chat-picker__close" @click="smiles = false">
          <img src="@/assets/images/icons/icon_close.svg" />
        </div>
          <EmojiPicker
            :emojiSize="24"
            :emojisByRow="6"
            :continuousList="true"
            @select="addSmile"/>
        </div>
    <!-- Изображение -->
    <div class="new-block-image" :class="getImageClass()" v-if="block.type === 'image'">
      <div
        class="image"
        v-for="(image, index) in block.value"
        :key="index"
        :class="{ 'full-width': image.type == 'jpeg' }"
      >
        <img :src="image.url" v-if="image.url" />
          <Icons :icon="'loader'" />
        <div class="image-panel">
          
          <div class="image-panel__item add" v-if="addMore">
            <input
              class="new-block-image__input"
              type="file"
              multiple
              @change="readFile"
              name="myImage"
              max-size="10000"
              accept="image/*"
            />
            <Icons :icon="'plus'" />
          </div>
          <div class="image-panel__item" @click="deleteImage(image, index)">
            <Icons :icon="'delete'" />
          </div>
        </div>
      </div>

      <!-- Добавить изображение -->
      <div class="new-block-image__add" v-if="block.value.length < 1">
        <input
          class="new-block-image__input"
          type="file"
          multiple
          @change="readFile"
          name="myImage"
          max-size="5000"
          accept="image/*"
        />
        <Icons :icon="'plus'" />
        <p>Добавить изображение (до 10MB)</p>
      </div>
    </div>
    <div class="new-block__delete" @click="deleteBlock()">
      <Icons :icon="'delete'" />
    </div>
    <div class="new-block-arrows" v-if="navigation">
      <div class="new-block-arrow" @click="$emit('moveUp', index)">
        <font-awesome-icon icon="chevron-up" />
      </div>
      <div class="new-block-arrow" @click="$emit('moveDown', index)">
        <font-awesome-icon icon="chevron-down" />
      </div>
    </div>
  </div>
</template>
<script>
import emoji from '@/data/emoji.json';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Icons from './components/Icons.vue'

import { VEmojiPicker } from 'v-emoji-picker';

library.add(faChevronUp, faChevronDown);

export default {
  name: 'Block',
  data: () => {
    return {
      images: [],
      smiles: false,
      emoji,
    };
  },
  props: {
    block: {
      type: Object,
      require: true,
    },
    placeholder: {
      type: String,
      require: false,
      default: 'Этот абзац лучше предыдущего'
    },
    index: {
      type: Number,
      require: true,
    },
    navigation: {
      type: Boolean,
      require: false,
      default: false
    },
    addMore: {
      type: Boolean,
      require: false,
      default: true
    },
    path: {
      type: String,
      require: false,
      default: 'events'
    }
  },
  components: {
    EmojiPicker: VEmojiPicker,
    Icons
  },
  methods: {
    showImageChange(type) {
      let result = true;
      !this.addMore ? type === 'image' ? '' : result = false : '';
      return result
    },
    changeType(type) {
      this.$emit('changeType', { type: type, index: this.index });
    },
    changeValue(value) {
      this.$emit('changeValue', { value, index: this.index });
    },
    getImageClass() {
      let result = '';
      switch (this.block.value.length) {
        case 1:
          result = 'new-block-image_one';
          break;
        case 2:
          result = 'new-block-image_two';
          break;
        case 3:
          result = 'new-block-image_tree';
          break;
        case 4:
          result = 'new-block-image_four';
          break;
        case 5:
          result = 'new-block-image_five';
          break;
        case 6:
          result = 'new-block-image_six';
          break;

        default:
          break;
      }
      return result;
    },
    readFile(input) {
      let files = input.target.files;
      files.length > 6
        ? this.$store.dispatch('addError', {
            message: 'Допустимо максимум 6 фотографий в одном блоке',
          })
        : '';
      files.forEach(async (element, index) => {
        if (index < 6) {
          if (element.size / 1024 > 10000) {
            this.$store.dispatch('addError', {message: 'Размер одной из фотографий превышает 10MB'});
          } else {
            var reader = new FileReader();
            reader.readAsDataURL(element)
            reader.onload = async () => {
              let url = reader.result;
              let type = element.type.split('/')[1];
              let size = element.size / 1024;
              let name = this.$moment().format('ss-mm-HH_DD-MM-YYYY') + '_' + Math.round(Math.random() * 1000);
              let path = this.path;
              this.block.value.push({
                url: null,
                key: null,
                type
              });
              let index = this.block.value.length - 1;
              await this.$store.dispatch('uploadImage', {url, type: type || 'jpeg', name, size, path})
                .then(response => {
                  response.Location ? (this.block.value[index].url = response.Location, this.block.value[index].key = response.key) : (this.block.value.splice(index, 1), this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'}));
                }).catch(e => {e
                  this.block.value.splice(index, 1);
                  this.$store.dispatch('addError', {message: 'Не удалось загрузить изображение'})
                });
            };

            reader.onerror = function() {
              this.$store.dispatch('addError', {message: 'Что-то пошло не так...'})
            };
            
            
          }
        }
      });
    },
    async deleteImage(image, index) {
      await this.$store.dispatch('deleteImage', {key: image.key ? image.key : image.url})
      this.block.value.splice(index, 1);
    },
    async deleteBlock() {
      this.$emit('deleteBlock', this.index)
      if (this.block.type === 'image') {
        this.block.value.forEach(image => {
          this.$store.dispatch('deleteImage', {key: image.key ? image.key : image.url})
        })
      }
    },
    openSmiles() {
      this.smiles = !this.smiles;
    },
    addSmile(smile) {
      this.block.value = this.block.value ? this.block.value += smile.data : smile.data;
    },
  }
};
</script>
